// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

const leadGeneratorUnit = require("../../../../Assets/images/landing-page/landing-page-features-unit-01.png");

type PropsType = {
  translate: string => void
};

type StateType = {};

class LeadGeneratorUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <section className="section bg-gray overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-center text-center text-md-left">
              <h2>{translate("LandingPageLocale.lead_generator_unit.header")}</h2>
              <br />
              <p>
                {translate("LandingPageLocale.lead_generator_unit.content")}
              </p>
              <br />
              <Link to="/kayit-ol" className="btn btn-lg btn-round btn-primary shadow-3">
              {translate("LandingPageLocale.lead_generator_unit.action")}
              </Link>
            </div>

            <div className="col-md-5 mx-auto text-center mt-8 mt-md-0">
              <img src={leadGeneratorUnit} alt="envanterium-terminal-screen" data-aos="fade-up" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default LeadGeneratorUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/LandingPage/LeadGeneratorUnit.js